// extracted by mini-css-extract-plugin
export default {"navlink":"NavTabs_navlink__xWn3A","active":"NavTabs_active__itBrl"};